import script from "./TradeDashboardItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TradeDashboardItem.vue?vue&type=script&setup=true&lang=js"

import "./TradeDashboardItem.vue?vue&type=style&index=0&id=377e624a&lang=css"

const __exports__ = script;

export default __exports__